import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import api from '~/services/api';
import apiFxAdmin from '~/services/apiFxAdmin';
import axios from 'axios';

import {
  requestPautasSuccess,
  requestPautasFailure,
  requestMateriasSuccess,
  requestMateriasFailure,
  requestSavePautaSuccess,
  requestConteudosSuccess,
  requestConteudosFailure,
  requestPautas as requestPautasAction,
  requestAlunosSuccess,
  requestConteudos,
} from './actions';

export function* requestPautas({ payload }) {
  const { filtros, turma, materia } = payload;
  try {
    const response = yield call(api.get, `aulas/${turma}/${materia}`, {
      params: { ...filtros },
    });

    yield put(requestPautasSuccess(response.data));

    try {
      const alunosResponse = yield call(api.get, `pauta/${turma}/${materia}`);
      const { alunos, datas, dados } = alunosResponse.data;
      const proximaAula = (datas.length && datas[datas.length - 1]) || null;

      const orderedAlunos =
        (alunos.length &&
          alunos.sort((a, b) =>
            a.aluno.toLowerCase() > b.aluno.toLowerCase() ? 1 : -1
          )) ||
        [];

      yield put(requestAlunosSuccess(orderedAlunos, proximaAula, dados));

      if (proximaAula) {
        yield put(requestConteudos(proximaAula.aula_id));
      }
    } catch (alunosErr) {
      console.error('Failed to fetch alunos data:', alunosErr);
    }
  } catch (err) {
    if (err.response) {
      if (
        err.response.data.error ===
        'Ocorreu um erro ao tentar configurar sessão.'
      ) {
        yield put(requestPautasAction({ filtros, turma, materia }));
      }
      return;
    }
    toast.error('Falha na requisição, contacte o suporte.');
    yield put(requestPautasFailure());
  }
}

export function* requestSaveSchedule({ payload }) {
  try {
    yield put({ type: '@pautas/SET_SAVING_PAUTA', payload: { saving: true } });

    yield put({
      type: '@pautas/SET_SAVE_STATUS',
      payload: { status: 'Salvando pauta...' },
    });

    const { pauta, filtros, turma, materia } = payload;

    yield call(api.post, 'pauta', pauta);

    yield put(requestSavePautaSuccess());

    yield put(requestPautasAction({ filtros, turma, materia }));

    yield put({
      type: '@pautas/SET_SAVE_STATUS',
      payload: { status: 'Pauta salva com sucesso!' },
    });

    toast.success('Pauta salva com sucesso.');

    const pending = yield select(state => state.pautas.pendingUploadArquivos);
    if (!pending) {
      yield new Promise(resolve => setTimeout(resolve, 1500));
      yield put({ type: '@pautas/CLOSE_MODAL' });
    } else {
      console.log(
        '[pautas][requestSaveSchedule] Existem uploads pendentes, mantendo modal aberto'
      );
    }
  } catch (err) {
    yield put({
      type: '@pautas/SET_SAVE_STATUS',
      payload: { status: 'Erro ao salvar pauta.' },
    });

    toast.error('Falha na requisição, contacte o suporte.');

    yield put({ type: '@pautas/CLOSE_MODAL' });
  } finally {
    yield put({ type: '@pautas/SET_SAVING_PAUTA', payload: { saving: false } });
  }
}

export function* requestMaterias({ payload }) {
  try {
    const { turma } = payload;
    const response = yield call(api.get, `turma/${turma}/materias`);

    const groupBy = (array, property) => {
      return array.reduce((value, key) => {
        (value[key[property]] = value[key[property]] || []).push(key);
        return value;
      }, {});
    };

    yield put(requestMateriasSuccess(groupBy(response.data, 'status')));
  } catch (err) {
    toast.error('Falha na requisição, contacte o suporte.');
    yield put(requestMateriasFailure());
  }
}

export function* requestConteudosAula({ payload }) {
  try {
    const { aula } = payload;
    const response = yield call(api.get, `aula/${aula}/conteudos`);

    yield put(requestConteudosSuccess(response.data));
  } catch (err) {
    toast.error('Falha na requisição, contacte o suporte.');
    yield put(requestConteudosFailure());
  }
}

const FILE_EXTENSION_ID_MAP = {
  jpg: 2,
  jpeg: 15,
  png: 3,
  pdf: 14,
};

export function* uploadArquivos({ payload }) {
  try {
    yield put({
      type: '@pautas/SET_UPLOADING_FILES',
      payload: { uploading: true },
    });

    yield put({
      type: '@pautas/SET_FETCHING_CLASS_DATA',
      payload: { fetching: true },
    });
    yield put({
      type: '@pautas/SET_SAVE_STATUS',
      payload: { status: 'Buscando dados da aula para upload de arquivos...' },
    });

    const {
      turmaId,
      materiaId,
      files,
      unidadeId,
      description,
      alunoIds,
    } = payload;

    // Fetch class data to get the latest aula_id
    const response = yield call(api.get, `aulas/${turmaId}/${materiaId}`);
    const aulas = response.data || [];
    const aula = aulas.length ? aulas[aulas.length - 1] : null;

    if (!aula || !aula.aula_id) {
      yield put({
        type: '@pautas/SET_SAVE_STATUS',
        payload: {
          status: 'Não foi possível localizar a aula para upload de arquivos.',
        },
      });
      toast.error(
        'Não foi possível localizar a aula salva para anexar os arquivos.'
      );
      yield put({
        type: '@pautas/SET_FETCHING_CLASS_DATA',
        payload: { fetching: false },
      });
      return;
    }

    yield put({
      type: '@pautas/SET_SAVE_STATUS',
      payload: { status: 'Iniciando upload de arquivos...' },
    });

    const aulaId = aula.aula_id;

    yield put({
      type: '@pautas/SET_FETCHING_CLASS_DATA',
      payload: { fetching: false },
    });

    if (!aulaId) {
      yield put({
        type: '@pautas/SET_SAVE_STATUS',
        payload: { status: 'Aula não identificada para upload.' },
      });
      toast.error(
        'Aula não identificada para upload. Tente salvar a pauta novamente.'
      );
      return;
    }

    for (let i = 0; i < files.length; i += 1) {
      const file = files[i];
      console.log(`Processing file ${i + 1}/${files.length}:`, {
        name: file.name,
        size: file.size,
        type: file.type,
      });

      yield put({
        type: '@pautas/SET_SAVE_STATUS',
        payload: {
          status: `Fazendo upload do arquivo ${i + 1} de ${files.length}: ${
            file.name
          }...`,
        },
      });

      const extension = file.name
        .split('.')
        .pop()
        .toLowerCase();
      const fileExtensionId = FILE_EXTENSION_ID_MAP[extension];

      if (!fileExtensionId) {
        console.log(
          `Warning: Unknown file extension '${extension}', fileExtensionId will be undefined`
        );
      }

      const payloadLink = {
        unidade_id: unidadeId,
        pessoa_id: alunoIds,
        aula_id: aulaId,
        description,
        type: 2,
        subtype: 20,
        file_extension: fileExtensionId,
        size: file.size,
      };

      const linkResponse = yield call(
        apiFxAdmin.post,
        '/unidade/anexos/linkUpload',
        payloadLink
      );

      const { link_id, urlUpload } = linkResponse.data || {};

      if (!link_id || !urlUpload) {
        yield put({
          type: '@pautas/SET_SAVE_STATUS',
          payload: { status: 'Falha ao obter link de upload.' },
        });
        toast.error('Falha ao obter link de upload.');
        return;
      }

      try {
        yield call(axios.put, urlUpload, file, {
          headers: {
            'Content-Type': file.type || 'application/octet-stream',
          },
        });
      } catch (uploadError) {
        console.log('Error during file upload to URL:', uploadError);
        throw uploadError; // Re-throw to be caught by the main try-catch
      }

      const responseConfirm = yield call(
        apiFxAdmin.post,
        '/unidade/anexos/confirmLinkUpload',
        {
          link_id,
          unidade_id: unidadeId,
          aula_id: aulaId,
        }
      );
      if (!responseConfirm.data || responseConfirm.data.result === false) {
        yield put({
          type: '@pautas/SET_SAVE_STATUS',
          payload: { status: 'Falha ao confirmar upload.' },
        });
        toast.error('Falha ao confirmar upload.');
        return;
      }

      yield put({
        type: '@pautas/SET_SAVE_STATUS',
        payload: {
          status: `Arquivo ${i + 1} de ${files.length} enviado com sucesso!`,
        },
      });
      toast.success(`Arquivo ${file.name} enviado com sucesso!`);
    }

    yield put({
      type: '@pautas/SET_SAVE_STATUS',
      payload: { status: 'Todos os arquivos foram enviados com sucesso!' },
    });
  } catch (error) {
    console.log('Error details:', {
      response: error.response ? error.response.data : undefined,
      message: error.message,
    });

    yield put({
      type: '@pautas/SET_SAVE_STATUS',
      payload: {
        status: `Erro ao fazer upload dos arquivos: ${(error.response &&
          error.response.data &&
          (error.response.data.error || error.response.data.message)) ||
          error.message ||
          'Erro desconhecido'}`,
      },
    });

    toast.error(
      (error.response &&
        error.response.data &&
        (error.response.data.error || error.response.data.message)) ||
        error.message ||
        'Erro ao fazer upload dos arquivos.'
    );
  } finally {
    yield put({
      type: '@pautas/SET_UPLOADING_FILES',
      payload: { uploading: false },
    });
    yield new Promise(resolve => setTimeout(resolve, 1500));
    yield put({ type: '@pautas/CLOSE_MODAL' });
  }
}

export function* handleUploadAfterSave() {
  const pending = yield select(state => state.pautas.pendingUploadArquivos);

  if (!pending) {
    return;
  }

  try {
    yield put({
      type: '@pautas/SET_SAVE_STATUS',
      payload: { status: 'Iniciando processo de upload de arquivos...' },
    });

    yield put({
      type: '@pautas/REQUEST_UPLOAD_ARQUIVOS',
      payload: pending,
    });
  } catch (e) {
    yield put({
      type: '@pautas/SET_SAVE_STATUS',
      payload: { status: 'Erro ao iniciar processo de upload.' },
    });
    toast.error('Falha ao iniciar processo de upload.');
  } finally {
    yield put({ type: '@pautas/CLEAR_PENDING_UPLOAD_ARQUIVOS' });
  }
}

export default all([
  takeLatest('@pautas/REQUEST_PAUTAS', requestPautas),
  takeLatest('@pautas/REQUEST_MATERIAS', requestMaterias),
  takeLatest('@pautas/REQUEST_SAVE_NEW_SCHEDULE', requestSaveSchedule),
  takeLatest('@pautas/REQUEST_CONTEUDOS', requestConteudosAula),
  takeLatest('@pautas/NEW_SCHEDULE_SAVE_SUCCESS', handleUploadAfterSave),
  takeLatest('@pautas/REQUEST_UPLOAD_ARQUIVOS', uploadArquivos),
]);
